var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Do not edit this file, it is auto generated
 */
import { StyledSvgIcon } from '../../styles/svg-icon.styled';
export const SocialInstagramIcon = (_a) => {
    var { size = 'md' } = _a, props = __rest(_a, ["size"]);
    return (_jsxs(StyledSvgIcon, Object.assign({ xmlSpace: "preserve", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", "$size": size }, props, { children: [_jsx("path", { d: "M16.051 9.492a6.815 6.815 0 0 0-6.807 6.807 6.815 6.815 0 0 0 6.807 6.808 6.816 6.816 0 0 0 6.808-6.808c.001-3.753-3.053-6.807-6.808-6.807m0 10.615c-2.099 0-3.807-1.709-3.807-3.808s1.708-3.807 3.807-3.807 3.808 1.708 3.808 3.807-1.708 3.808-3.808 3.808" }), _jsx("path", { d: "M22.396 3.1H9.571A6.51 6.51 0 0 0 3.07 9.602v12.825a6.51 6.51 0 0 0 6.501 6.501h12.825a6.51 6.51 0 0 0 6.501-6.501V9.602A6.51 6.51 0 0 0 22.396 3.1m3.5 19.327a3.504 3.504 0 0 1-3.499 3.501H9.571a3.506 3.506 0 0 1-3.501-3.501V9.602a3.506 3.506 0 0 1 3.501-3.501h12.825a3.504 3.504 0 0 1 3.499 3.501z" }), _jsx("path", { d: "M22.898 7.915a1.539 1.539 0 1 0 0 3.078 1.539 1.539 0 0 0 0-3.078" })] })));
};
